import React from 'react';
import { Link, useParams } from 'react-router-dom';

const productData = {
  epadasalai: {
    name: 'ePadasalai',
    eyebrow: 'Complete Education Management ERP',
    intro: 'One powerful platform for your entire institution. ePadasalai simplifies, automates, and connects academic, administrative, financial, HR, communication, and operational activities in one centralized system.',
    outcomes: ['Manage the complete institution digitally with 95+ integrated modules', 'Access information anywhere through a browser, smartphone, tablet, Android device, or iPhone', 'Connect management, administrators, teachers, students, parents, and alumni', 'Generate 600+ reports and export information to Word, Excel, and PDF'],
    capabilities: ['Administration and student management', 'Academic and examination management', 'Finance, fees, and online payments', 'HR, payroll, and staff attendance', 'Transportation, GPS tracking, and geo-fencing', 'Library, eLibrary, and digital resources'],
    audiences: [
      { title: 'Schools', text: 'Academic, administrative, financial, student, parent, teacher, and management requirements.' },
      { title: 'Colleges', text: 'Campus management capabilities for higher education institutions.' },
      { title: 'Universities', text: 'Student information, HR, finance, departments, divisions, and multiple locations.' },
      { title: 'Training Centres', text: 'Dedicated modules for training organizations and their daily activities.' },
      { title: 'Online Schools', text: 'e-Tuition, eLibrary, online examinations, academic content, and digital learning.' },
    ],
    moduleGroups: [
      { title: 'Administration', items: ['Admission Processing', 'Student Management', 'Attendance', 'Timetable and Class Scheduler', 'School Calendar', 'Event Management', 'Multi-School Management', 'User and Access Management'] },
      { title: 'Academic Management', items: ['Examination Management', 'Exam Scheduling', 'Exam Room Planning', 'Teacher Planner', 'Report Cards', 'Rank and Grade Management', 'Teacher Substitution', 'Homework and Assignments'] },
      { title: 'Finance and Fees', items: ['Fee Management', 'Fee Structures', 'Online Fee Payment', 'Accounts and Finance', 'Cash and Bank Transactions', 'Receipts and Payments', 'Trial Balance', 'Profit and Loss', 'Financial Reports'] },
      { title: 'HR, Transport and Library', items: ['Employee and Payroll Management', 'Payslips and Leave Management', 'Vehicle and Route Management', 'GPS Vehicle Tracking', 'Geo-Fencing', 'Library Management', 'Online Library', 'Digital Resources'] },
    ],
    implementation: ['Understand your institution\'s requirements', 'Configure modules and workflows', 'Migrate existing data', 'Train management, teachers, and staff', 'Launch the integrated education ERP', 'Provide ongoing assistance and maintenance'],
    contact: true,
  },
  thekallos360: {
    name: 'TheKallos360',
    eyebrow: 'Salon Management System',
    intro: 'A cloud-hosted Beauty and Wellness Management System designed to digitize day-to-day administration and business operations for salons, spas, wellness centers, and beauty clinics.',
    outcomes: ['Bring daily salon operations into one connected platform', 'Give teams clearer visibility into customers, bookings, billing, and stock', 'Deliver more consistent appointment and customer communication', 'Support growth with 25+ purpose-built business modules'],
    capabilities: ['Customer CRM', 'Appointments and staff availability', 'Billing, packages, and payments', 'Inventory and retail sales', 'Offers and discount controls', 'Analytics and business reports'],
    whatsapp: ['Transactional messages and appointment notifications', 'Promotional messages and reusable templates', 'Delivery and read reports', 'Customer opt-in and opt-out management', 'Use of the business\'s own WhatsApp Business number and display name'],
  },
};

const ProductDetail = () => {
  const { productId } = useParams();
  const product = productData[productId] || productData.epadasalai;

  return (
    <>
      <section className="py-5 text-white" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
        <div className="container py-4">
          <Link to="/products" className="text-white text-decoration-none small">Products /</Link>
          <p className="text-uppercase small fw-semibold mt-4 mb-2" style={{ color: '#bfdbfe' }}>{product.eyebrow}</p>
          <h1 className="display-4 fw-bold">{product.name}</h1>
          <p className="lead mb-0" style={{ color: '#dbeafe', maxWidth: 760 }}>{product.intro}</p>
        </div>
      </section>

      <section className="py-5 bg-white">
        <div className="container py-3">
          <div className="row g-5">
            <div className="col-lg-6">
              <span className="text-primary small fw-bold">WHY IT MATTERS</span>
              <h2 className="fw-bold mt-2 mb-4">Designed around the people who use it</h2>
              <ul className="list-group list-group-flush">
                {product.outcomes.map(outcome => <li className="list-group-item px-0 py-3" key={outcome}>{outcome}</li>)}
              </ul>
            </div>
            <div className="col-lg-5 offset-lg-1">
              <div className="p-4 rounded-3" style={{ background: '#eff6ff', borderLeft: '4px solid #1a56db' }}>
                <span className="text-primary small fw-bold">CORE CAPABILITIES</span>
                <ul className="mt-3 mb-0 ps-3">
                  {product.capabilities.map(capability => <li className="mb-3" key={capability}>{capability}</li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {product.audiences && (
        <section className="py-5 bg-light">
          <div className="container py-3">
            <span className="text-primary small fw-bold">ONE PLATFORM, MANY INSTITUTIONS</span>
            <h2 className="fw-bold mt-2 mb-4">Complete education management for every environment</h2>
            <div className="row g-3">
              {product.audiences.map(audience => (
                <div className="col-12 col-md-6 col-lg-4" key={audience.title}>
                  <div className="card border-0 shadow-sm h-100 p-3">
                    <h5 className="fw-bold text-primary">{audience.title}</h5>
                    <p className="text-muted mb-0">{audience.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {product.moduleGroups && (
        <section className="py-5 bg-white">
          <div className="container py-3">
            <span className="text-primary small fw-bold">95+ INTEGRATED MODULES</span>
            <h2 className="fw-bold mt-2 mb-4">Powerful modules for every department</h2>
            <div className="row g-4">
              {product.moduleGroups.map(group => (
                <div className="col-12 col-md-6" key={group.title}>
                  <div className="border rounded-3 p-4 h-100">
                    <h5 className="fw-bold mb-3">{group.title}</h5>
                    <div className="row row-cols-1 row-cols-sm-2 g-2">
                      {group.items.map(item => <div className="col text-muted small" key={item}>• {item}</div>)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {product.implementation && (
        <section className="py-5 bg-light">
          <div className="container py-3">
            <div className="row g-5 align-items-center">
              <div className="col-lg-5">
                <span className="text-primary small fw-bold">IMPLEMENTATION SUPPORT</span>
                <h2 className="fw-bold mt-2">Move from manual processes with confidence</h2>
                <p className="text-muted">ePadasalai supports data migration, customization, training, launch, and ongoing maintenance, so institutions do not have to start from zero.</p>
              </div>
              <div className="col-lg-6 offset-lg-1">
                <div className="row g-3">
                  {product.implementation.map((step, index) => <div className="col-12 col-sm-6" key={step}><div className="d-flex gap-2"><span className="text-primary fw-bold">{String(index + 1).padStart(2, '0')}</span><span>{step}</span></div></div>)}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {product.whatsapp && (
        <section className="py-5 bg-light">
          <div className="container py-3">
            <div className="row g-5 align-items-center">
              <div className="col-lg-5">
                <span className="text-success small fw-bold">WHATSAPP BUSINESS</span>
                <h2 className="fw-bold mt-2">Keep customer conversations connected</h2>
                <p className="text-muted">TheKallos360 supports business messaging through the salon's own WhatsApp Business number and display name.</p>
              </div>
              <div className="col-lg-6 offset-lg-1">
                <ul className="list-group list-group-flush shadow-sm">
                  {product.whatsapp.map(item => <li className="list-group-item py-3" key={item}>{item}</li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}

      <section className="py-5 bg-light text-center">
        <div className="container py-3">
          <h2 className="fw-bold">{product.contact ? 'Ready to digitize your institution?' : 'Build a product with purpose'}</h2>
          <p className="text-muted mb-4">{product.contact ? 'Experience ePadasalai with a free demo and see how one platform can connect your entire institution.' : 'Talk with our team about your next digital product or platform.'}</p>
          <Link to="/contact" className="btn btn-primary px-4">{product.contact ? 'Request a Free Demo' : 'Start a conversation'}</Link>
        </div>
      </section>
    </>
  );
};

export default ProductDetail;
